import { CollectionFactory } from "@/collections/CollectionFactory";
import { ModelFactory } from "@/models/ModelFactory";

const fetchCollection = async (collection, message) => {
  try {
    await collection.fetch();

    return collection;
  } catch ({ response }) {
    const { status, data } = response.response;
    
    message.toast(`Code: ${status}. ${data.error || data.message}`, {
      title: "Server Error.",
      variant: "danger",
    });

    return null;
  }
};

const fetchModel = async (model, message) => {
  try {
    await model.fetch();
    return model;
  } catch ({ response }) {
    const { status, data } = response.response;
    
    message.toast(data.error
      ? `Code: ${status}. ${data.error}`
      : "Model not found.", {
      title: "Server Error.",
      variant: "danger"
    });

    return null;
  }
};

const extendCollection = async ({
  message,
  collection,
  filters,
  connections,
  sort,
  limit,
  page,
}) => {
  const filter = collection.getFilter();

  connections &&
    connections.forEach((connection) => {
      filter.connectionAdd(connection);
    });
  sort &&
    sort.forEach(({ logic, field }) => {
      filter[logic](field);
    });
  filters &&
    filters.forEach(({ logic, field, value }) => {
      value && field
        ? filter[logic](field, value)
        : filter[logic](field || value);
    });
  limit && filter.setLimit(limit);
  page && filter.setPage(page);

  return fetchCollection(collection, message);
};

export const getModel = async ({ model_type, id, message }) => {
  const default_model = ModelFactory.get(model_type);
  const model = new default_model({ id });

  return fetchModel(model, message);
};

export const getCollection = async ({
  collection_type,
  filters,
  connections,
  sort,
  limit,
  page,
  message,
}) => {
  const default_collection = CollectionFactory.get(collection_type);
  const collection = new default_collection();

  return await extendCollection({
    message,
    collection,
    filters,
    connections,
    sort,
    limit,
    page,
  });
};
